import * as React from "react";
import { Form, FormActions } from "./Form.jsx";
import { Button } from "./Button.jsx";
import { CheckBox } from "./CheckBox.jsx";
import { ComboBox } from "./ComboBox.jsx";
import { NumberBox } from "./NumberBox.jsx";
import { TextBox } from "./TextBox.jsx";
import { SchemaJSON } from "./SchemaJSON.js";
import * as cls from "./FormJSON.module.scss";
import FileUpload from "./FileUpload.jsx";
import imageIcon from "./FormJSON.png.png";
import pdfIcon from "./FormJSON.pdf.png";
export { FormJSON };
/**
 * Генератор простых форм по схеме JSON.
 * @extends {React.Component}
 * @property {Object} props - Атрибуты элемента.
 * @property {"column"|"row"|"grid"} [props.layout="column"] - Макет формы.
 * @property {SchemaJSON} props.schema - Схема JSON.
 * @see {@link ../product/SectionFormJSON.jsx}
 * Форма c заголовком, оформленная как секция учебного продукта.
 * @see {@link SchemaJSON.js}
 * @example
 * <FormJSON schema={schema}/>;
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
class FormJSON extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sending: false,
    };
    this.onChange = this.onChange.bind(this);
    this.removeFile = this.removeFile.bind(this);
    // Настройки поля формы
    if (this.props.schema.properties)
      for (const field in this.props.schema.properties) {
        const property = this.props.schema.properties[field];
        if (property.title === "Вложения") {
          this.state[field] = [];
          if (undefined !== property.default) {
            this.state[field].push(property.default);
          } else if (property.enum) {
            this.state[field].push(property.enum[0]);
          }
        } else {
          if (undefined !== property.default)
            this.state[field] = property.default;
          else if (property.enum) this.state[field] = property.enum[0];
          else this.state[field] = null;
        }
      }
  }
  async handleSubmit(event) {
    event.preventDefault();
    this.setState({ sending: true });
    const inputData = this.state;
    try {
      await this.props.schema.onSubmit(inputData);
    } catch (error) {
      console.log("Ошибка при отправке данных:", error);
    } finally {
      this.setState({ sending: false });
    }
  }
  renderProgress() {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <progress
          style={{
            height: "15px",
            borderRadius: "8px",
          }}
          value={this.props.progress}
          max={100}
        />
        <strong style={{ marginLeft: "10px" }}>{this.props.progress}%</strong>
      </div>
    );
  }
  /**
   * Обработчик события изменения значения поля.
   * @param {Event} event - Событие.
   * @private
   */
  onChange(event) {
    const name = event.target.name;
    const property = this.props.schema.properties[name];
    const value = this.parseValue(property, event.target);

    if (value instanceof Promise) {
      value
        .then((combinedData) => {
          this.setState((prevState) => ({
            [name]: [...prevState[name], combinedData],
          }));
        })
        .catch((error) => {
          console.error("Ошибка при преобразовании файла:", error);
        });
    } else {
      //console.debug(name, event.target.value, value);
      this.setState({ [name]: value });
    }
  }
  /**
   * Парсит значение поля.
   * @param {SchemaJSON~Property} property - Свойство из схемы JSON.
   * @param {HTMLElement} input - Элемент ввода.
   * @returns {JSX.Element} Элемент JSX.
   */
  parseValue(property, input) {
    switch (property.type) {
      case SchemaJSON.Type.BOOLEAN:
        return !!input.checked;
      case SchemaJSON.Type.INTEGER:
        return parseInt((input.value ?? "0").trim());
      case SchemaJSON.Type.NUMBER:
        return parseFloat((input.value ?? "0").trim());
      case SchemaJSON.Type.ARRAY:
        if (input.files[0]) {
          return new Promise((resolve, reject) => {
            const file = input.files[0];
            const reader = new FileReader();
            const mimeType = file.type;
            reader.onloadend = () => {
              const base64Data = reader.result.split(",")[1]; // отделяем base64 от prepended text
              const dataUrl = `data:${mimeType};name=${file.name};base64,${base64Data}`;
              resolve(dataUrl);
            };
            reader.onerror = () => {
              reject(new Error("Ошибка чтения файла"));
            };

            reader.readAsDataURL(file);
          });
        }
        return Promise.resolve(null);
      case SchemaJSON.Type.STRING:
        return input.value ?? "";
      default:
        return input.value;
    }
  }
  /**
   * @returns {Object|Array} Словарь {надпись: значение} или массив значений.
   * @param {SchemaJSON~Property} property - Свойство из схемы JSON.
   */
  getComboBoxOptions(property) {
    if (!property.enumTitle) return property.enum;
    const dictionary = {};
    for (let i = 0; i < property.enumTitle.length; ++i)
      dictionary[property.enumTitle[i]] = property.enum[i];
    return dictionary;
  }
  renderFiles() {
    const filesSections = Object.entries(this.state).map(
      ([fieldName, files]) => {
        return (
          fieldName === "attachments" &&
          files.length > 0 && (
            <>
              <h3>Загруженные файлы:</h3>
              {files.map((dataUrl, index) => {
                const fileName = dataUrl.split("name=")[1].split(";")[0];
                const fileExtension = fileName.split(".").pop().toLowerCase();
                return (
                  <div className={cls.uploadedFile_root}>
                    <div className={cls.uploadedFile}>
                      <div
                        style={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                        key={`${fieldName}-${index}`}
                      >
                        <div style={{ display: "flex" }}>
                          <img
                            style={{ height: 20, marginRight: "10px" }}
                            src={fileExtension === "pdf" ? pdfIcon : imageIcon}
                          />
                          <h4 title={fileName}>{fileName}</h4>{" "}
                        </div>
                      </div>

                      <button
                        title="Удалить файл"
                        className={cls.removeFileButton}
                        onClick={(e) => {
                          e.preventDefault();
                          this.removeFile(fieldName, index);
                        }}
                      >
                        ✖
                      </button>
                    </div>
                    {this.props.errorFiles && (
                      <div
                        style={{ color: "rgb(255, 0, 0)" }}
                        title={this.props.errorFiles[index]}
                      >
                        {this.props.errorFiles[index]}
                      </div>
                    )}
                  </div>
                );
              })}
            </>
          )
        );
      }
    );
    return <div>{filesSections}</div>;
  }

  removeFile(fieldName, index) {
    this.setState((prevState) => {
      const updatedFiles = [...prevState[fieldName]];
      updatedFiles.splice(index, 1);
      return { [fieldName]: updatedFiles };
    });
    this.props.setErrorFiles((files) => {
      if (files) {
        return files.filter((file, fileIndex) => fileIndex !== index);
      }
    });
  }
  /**
   * Отображает компонент.
   * @returns {JSX.Element} Элемент JSX.
   */
  render() {
    const schema = new SchemaJSON(this.props.schema);
    const fields = schema
      .getPropertyList()
      .map((property) => this.renderField(property));
    const buttons = schema.actions.map((action) => this.renderButton(action));

    return (
      <Form
        layout={this.props.layout || "column"}
        onSubmit={(event) => this.handleSubmit(event)}
      >
        {fields}
        {this.renderFiles()}
        <FormActions>
          {this.state.sending ? this.renderProgress() : buttons}
        </FormActions>
      </Form>
    );
  }

  /**
   * Отображает поле ввода.
   * @param {SchemaJSON~Property} property - Свойство из схемы JSON.
   * @returns {JSX.Element} Элемент JSX.
   */
  renderField(property) {
    if (property.enum) return this.renderComboBox(property);
    switch (property.type) {
      case SchemaJSON.Type.BOOLEAN:
        return this.renderCheckBox(property);
      case SchemaJSON.Type.INTEGER:
        return this.renderNumberBox(property, 1);
      case SchemaJSON.Type.NUMBER:
        return this.renderNumberBox(property, property.multipleOf);
      case SchemaJSON.Type.ARRAY:
        return this.renderFileUpload(property);
      case SchemaJSON.Type.STRING:
      default:
        return this.renderTextBox(property);
    }
  }

  /**
   * Отображает текстовое поле ввода.
   * @param {SchemaJSON~Property} property - Свойство из схемы JSON.
   * @returns {JSX.Element} Элемент JSX.
   */
  renderTextBox(property) {
    return (
      <TextBox
        className={property.style ? cls[property.style] : undefined}
        key={property.field}
        id={property.field}
        label={property.title}
        required={property.required}
        placeholder={property.placeholder}
        rows={property.rows}
        minLength={property.minLength}
        maxLength={property.maxLength}
        value={this.state[property.field]}
        onChange={this.onChange}
      />
    );
  }
  /**
   * Отображает числовое поле ввода.
   * @param {SchemaJSON~Property} property - Свойство из схемы JSON.
   * @param {number} step - Шаг изменения значения.
   * @returns {JSX.Element} Элемент JSX.
   */
  renderNumberBox(property, step) {
    return (
      <NumberBox
        className={property.style ? cls[property.style] : undefined}
        key={property.field}
        id={property.field}
        label={property.title}
        required={property.required}
        placeholder={property.placeholder}
        min={property.minimum}
        max={property.maximum}
        step={step}
        value={this.state[property.field]}
        onChange={this.onChange}
      />
    );
  }
  renderFileUpload(property, step) {
    return (
      <FileUpload
        className={property.style ? cls[property.style] : undefined}
        key={property.field}
        id={property.field}
        label={property.title}
        required={property.required}
        placeholder={property.placeholder}
        min={property.minimum}
        max={property.maximum}
        step={step}
        value={this.state[property.field]}
        onChange={this.onChange}
      />
    );
  }
  /**
   * Отображает флажок.
   * @param {SchemaJSON~Property} property - Свойство из схемы JSON.
   * @returns {JSX.Element} Элемент JSX.
   */
  renderCheckBox(property) {
    return (
      <CheckBox
        className={property.style ? cls[property.style] : undefined}
        key={property.field}
        id={property.field}
        label={property.title}
        required={property.required}
        value={this.state[property.field]}
        onChange={this.onChange}
      />
    );
  }
  /**
   * Отображает комбинированное поле ввода.
   * @param {SchemaJSON~Property} property - Свойство из схемы JSON.
   * @returns {JSX.Element} Элемент JSX.
   */
  renderComboBox(property) {
    const dictionary = this.getComboBoxOptions(property);
    return (
      <ComboBox
        className={property.style ? cls[property.style] : undefined}
        key={property.field}
        id={property.field}
        label={property.title}
        required={property.required}
        dictionary={dictionary}
        value={this.state[property.field]}
        onChange={this.onChange}
      />
    );
  }
  /**
   * Отображает кнопку.
   * @param {Action} action - Действие.
   * @returns {JSX.Element} Элемент JSX.
   * @see {@link ../frame/Action.js}
   */
  renderButton(action) {
    const onClick = !action.onClick
      ? undefined
      : (event) => {
          event.preventDefault();
          action.onClick(this.state);
        };
    return (
      <Button
        key={action.name}
        type={action.type}
        icon={action.icon}
        onClick={onClick}
      >
        {action.name}
      </Button>
    );
  }
}
